import { WithAuthorization } from "../../context";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { hideAppSpinner, showAppSpinner } from "../../context/Store/slices/appSpinnerSlice";

function ESGExplorer() {
  const { t } = useTranslation("translation", {
    keyPrefix: "esgExplorer"
  });
  const dispatch = useDispatch();

  const [hideIFrame, setHideIFrame] = useState(true);
  const sleep = ms => new Promise(
    resolve => setTimeout(resolve, ms)
  );

  useEffect(() => {
    dispatch(showAppSpinner());
  }, [dispatch]);

  const onFrameLoad = async event => {
    await sleep(5000);
    setHideIFrame(false);
    dispatch(hideAppSpinner());
  };

  return (
    <Flex justifyContent="center">
      <iframe
        title={t("page.title")}
        width="100%"
        height="1000"
        style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
        src="https://www.figma.com/proto/H3EvyrGMvnmvpDGVtMbYYq/Enterprise-value-module?embed_host=share&kind=&node-id=2245-6179&page-id=2032%3A5965&scaling=min-zoom&starting-point-node-id=2245%3A6179&viewport=-1287%2C33%2C0.24&hide-ui=1"
        allowFullScreen
        onLoad={onFrameLoad}
        hidden={hideIFrame}
      ></iframe>
    </Flex>
  );
}

export default WithAuthorization(ESGExplorer);